module.exports = __webpack_public_path__ + "img/alarm-sumitomolife.fafe5d7e.svg";